import { render, staticRenderFns } from "./DimishedValueDescription.vue?vue&type=template&id=1e4bfea3&"
import script from "./DimishedValueDescription.vue?vue&type=script&lang=js&"
export * from "./DimishedValueDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports